import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useUserPreferences } from '../contexts/UserPreferencesContext';
import ConversationalHome from '../components/ConversationalHome';

const PersonalizedWeatherPage = () => {
  const navigate = useNavigate();
  const { user, isOnboarded, loading } = useUserPreferences();

  // Redirect if not authenticated or not onboarded
  if (!loading && (!user || !isOnboarded)) {
    navigate('/');
    return null;
  }

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex items-center justify-center font-inter">
        <div className="animate-spin h-8 w-8 border-2 border-primary rounded-full border-t-transparent"></div>
      </div>
    );
  }

  return <ConversationalHome />;
};

export default PersonalizedWeatherPage;